import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { versionApi } from '@/api';
import { BackendVersion, ChangelogResponse } from './version.types';

/** Baked into the bundle by Vite (see vite.config.ts define block). */
export const FRONTEND_VERSION: string =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'dev';

const FIVE_MINUTES = 5 * 60 * 1000;

export const useBackendVersion = () =>
  useQuery<BackendVersion, AxiosError>({
    queryKey: ['version', 'backend'],
    queryFn: () => versionApi.getBackendVersion(),
    staleTime: FIVE_MINUTES,
    retry: 1,
  });

export const useChangelog = () =>
  useQuery<ChangelogResponse, AxiosError>({
    queryKey: ['version', 'changelog'],
    queryFn: () => versionApi.getChangelog(),
    staleTime: FIVE_MINUTES,
    retry: 1,
  });
